<script>
    import DesktopButton from '../../reusableitems/DesktopButton.svelte';
</script>
<section>
        <div class="maindiv">
            <div class="onediv">
                <p>6</p>
            </div>
            <div class="virtualhead">
                <p>Musicians & <br>Sound Artists</p>
            </div>
            <div class="descriptiontext" >
                <p>No party is complete without music. 
                </p>
                    <p style="padding: 1.85vh 0;">We’re gathering the most innovative creative  around the globe to tinker, converse and decide the future of entertainment and gaming. </p>
                    
                   <p style="font-weight: 700;">You're awarded an exclusive ticket to the party. Govern the rules of community and vote on the direction of the technology and get rewarded for it.</p>  
                   <p style="padding: 1.85vh 0;">And while you’re at it, let's agree on an official soundtrack (we won’t stop you if you want to compose one, promise!). 
                </p>
             </div>
             <div class="btn">
                <DesktopButton
                state = "Artists & Musicians"
                text="Join Musicians Governance Council"
                TextColor='black'
                BackColor= 'white'
                borderClr= '0.1vh solid black'
                AnimationColor= 'aqua'
                TextColor2='black' 
                TextColorAFter='black'
                BorderClrAfter='0.1vh  aqua'/>
             </div>
             <div class="sound">
                <img src="/images/Artist/sound.png" alt="" width="100%" height="100%">
             </div>
             <div class="soundvec">
                <img src="/images/Artist/vectorsound.png" alt="" width="100%" height="100%">
             </div>
        </div>
</section>
<style>
    .maindiv{
        position: relative;
        width: 165.370vh ;
        background-color: white;
        font-family: 'Orbitron';
        height: 100vh;
    }
    p{
        margin: 0;
    }
    .virtualhead{
        font-weight: 700;
        font-size: 5.556vh ;
        line-height: 5.556vh ;
        text-transform: uppercase;
        color: #000000;
        position: absolute;
        left: 23.704vh ;
        top: 25.093vh ;
    }
    .onediv{
        font-size: 55.556vh ;
        color: rgba(244, 238, 236, 0.5);
        text-transform: uppercase;
        font-weight: 700;
        line-height: 55.556vh ;
        position: absolute;
        left: 8.148vh ;
    }
    .descriptiontext{
        position: absolute;
        right: 4.907vh ;
        top: 9.815vh ;
        width: 72.963vh ;
        font-size: 1.852vh ;
        font-weight: 400;
        line-height: 2.593vh ;
        color: #000000;
        letter-spacing: 0.12vh;
    }
    .btn{
        position: absolute;
        right: 4.907vh ;
        top: 46.019vh ;
    }
    .sound{
        position: absolute;
        bottom: 0;
        width: 165.370vh ;
    }
    .sound::after{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
    .soundvec{
        position: absolute;
        bottom: 2.5vh;
        width: 53.463vh ;
        left: 54.1vh;
        animation: move 1.2s infinite;
    }
    .soundvec::after{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
    @keyframes move {
        0% {
            transform:scale(1.03);
        }
        100% {
            transform:scale(1);
        }
    }
    </style>